<template>
  <div class="flex h-full flex-grow flex-col justify-between gap-2">
    <div
      class="flex h-full flex-wrap content-center items-center gap-x-3 gap-y-4 transition-all duration-300"
      :class="{
        'justify-center': !isCollapsed,
        'justify-between': isCollapsed
      }"
    >
      <div v-if="isCollapsed"></div>
      <div
        v-if="isCollapsed"
        class="flex flex-col items-center justify-between gap-2"
      >
        <BlTextTitle3 :text="totalScore" class="text-slate-800" />
        <BlTextBody2 text="Total score" />
      </div>
      <div
        class="flex flex-shrink-0 items-center justify-center rounded-full bg-light-purple hover:bg-dark-purple-200 transition-all duration-300 cursor-pointer"
        :class="{
          'h-32 w-32 xl:h-48 xl:w-48': sessionStatus === 'draft',
          'h-48 w-48': !isCollapsed && sessionStatus !== 'draft',
          'h-24 w-24': isCollapsed && sessionStatus !== 'draft',
          'cursor-wait': scoreLoading,
          'pointer-events-none': sessionStatus !== 'ongoing'
        }"
        @click="onAddScore()"
      >
        <BlTextSubtitle3 text="Incident" class="text-pure-white" />
      </div>
    </div>

    <div v-if="!isCollapsed" class="pb-3 flex-shrink-0 space-y-1">
      <div class="flex items-center justify-between">
        <BlTextBody2 text="Interval" />
        <div>
          <BlTextBody2 :text="currentInterval" />
          <BlTextBody2 text="/" />
          <BlTextBody2 :text="intervalRound" />
        </div>
      </div>
      <div class="flex items-center justify-between">
        <BlTextBody2 text="Score in interval" />
        <BlTextBody2 :text="scoreInInterval" />
      </div>
      <div class="flex items-center justify-between">
        <BlTextBody2 text="Total score" />
        <BlTextBody2 :text="totalScore" />
      </div>
      <div class="flex items-center justify-between">
        <BlTextBody2 text="Percentage" />
        <BlTextBody2 :text="`${percentageScore}%`" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BlTextTitle3 from "../../BlTextTitle3.vue";
import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "MeasurementCardPartialIntervalRecording",
  components: {
    BlTextTitle3,
    BlTextSubtitle3,
    BlTextBody2,
    BlInputButton
  },
  props: {
    measurement: { type: Object, required: true },
    sessionStatus: { type: String, required: true },
    counter: { type: Number, required: false },
    isCollapsed: { type: Boolean, default: false }
  },
  data() {
    return {
      scoreLoading: false
    };
  },
  computed: {
    ...mapGetters(["viewMode"]),
    intervalRound() {
      const intervalCount =
        (this.measurement.target && this.measurement.target.interval) || 0;
      if (!this.measurement.target || !intervalCount) {
        return 1;
      }
      const duration =
        Object.keys(this.measurement.results).length * intervalCount;
      return duration / intervalCount;
    },
    currentInterval() {
      const intervalCount =
        this.measurement.target && this.measurement.target.interval;
      if (!this.counter) return 0;
      if (!this.measurement.target || !intervalCount) {
        return 1;
      }
      const interval = Math.ceil(this.counter / (intervalCount * 60));
      return interval > this.intervalRound ? this.intervalRound : interval;
    },
    scoreInInterval() {
      if (!this.measurement.results) return 0;
      if (!this.measurement.results[this.currentInterval - 1]) return 0;
      return this.measurement.results[this.currentInterval - 1];
    },
    totalScore() {
      if (!this.measurement.results) return 0;
      const results = Object.values(this.measurement.results);
      return results.reduce((a, b) => a + b, 0) || 0;
    },
    percentageScore() {
      if (!this.measurement.results) return 0;
      const res = Object.values(this.measurement.results).filter(a => a);
      return Math.floor((res.length / this.intervalRound) * 100);
    }
  },
  mounted() {},
  methods: {
    ...mapActions(["updateMeasurementResults"]),
    // ongoing
    async onAddScore() {
      if (this.sessionStatus !== "ongoing") return;
      if (this.scoreLoading) return;
      const interval = this.currentInterval - 1;
      const params = {
        id: this.measurement.id,
        results: interval
      };

      this.scoreLoading = true;
      await this.updateMeasurementResults(params);
      this.scoreLoading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/sessions/card/PartialIntervalRecording.vue